

















import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import CustomerStateHandler from '@root/common/components/helpers/CustomerStateHandler.vue';
import ArticleAuthorList from '@root/views/article/components/authors/ArticleAuthorList.vue';
import ArticleInfoSources from '@root/views/article/components/info/ArticleInfoSources.vue';
import ArticleInfoSocial from '@root/views/article/components/info/ArticleInfoSocial.vue';
import ArticleInfoTags from '@root/views/article/components/info/ArticleInfoTags.vue';
import ArticleInfoPaywallDisableCoundown from '@root/views/article/components/info/ArticleInfoPaywallDisableCountdown.vue';

interface Props {
  article: ArticleData;
}

export default Vue.extend<unknown, unknown, unknown, Props>({
  components: {
    ArticleAuthorList,
    ArticleInfoSources,
    ArticleInfoSocial,
    ArticleInfoTags,
    ArticleInfoPaywallDisableCoundown,
    CustomerStateHandler,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
});
